import React, { useState } from "react";

import CauseForImageManager from "./causeForConcernFormsManager/cause-for-image-manager";
import ConcernForIncidentManager from "./causeForConcernFormsManager/cause-for-incident-manager";
import CauseForWitnessManager from "./causeForConcernFormsManager/cause-for-witness-manager";

const CauseForConcernManager = ({ task, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0); // Step index

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <ConcernForIncidentManager incidentData={task?.incidentInfo} title={task?.title} nextStep={nextStep} />;
      case 1:
        return (
          <CauseForWitnessManager
            witnessRecords={task?.witnessInfo}
            witnessData={task?.witnessData}
            incidentTime={task?.incidentTime}
            place={task?.place}
            dateInformed={task?.dateInformed}
            prevStep={prevStep}
            nextStep={nextStep}
          />
        );
      case 2:
        return (
          <CauseForImageManager
            imageData={task?.imageInfo}
            uploadedFiles={task?.uploadedFiles}
            uploadedImages={task?.uploadedImages}
            selectedPerson={task?.gender}
            prevStep={prevStep}
            handleSubmit={onClose}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default CauseForConcernManager;
